module.exports = __webpack_public_path__ + "static/media/Relaxation Meditation Songs Divine - Вдчуваю любов.92690ba9.mp3";